import { memo } from 'react';
import { Box } from '@bonanza-social/moonlight';
import { StatusIndicatorProps } from './StatusIndicator.types';

function StatusIndicator({ visible }: StatusIndicatorProps) {
  if (!visible) {
    return;
  }

  return (
    <Box
      width="space-300"
      height="space-300"
      variant="gradient"
      borderRadius="radius-full"
      gradient="attentionBackground"
      position="absolute"
      right="-space-100"
      top="-space-100"
    />
  );
}

export default memo(StatusIndicator);
